'use strict';
/* ==========================================================================
   core-local/hooks.js — "The Ground Is Moving": this lesson's hooks into the shared engine v2
   (shared/engine/v2/core/game.js reads window.LessonHooks).

   speakers: the name tag + colour of each voice in the portrait dock's captions (core/dock.js). Colours are dark
             enough to read as text on the cream collage paper: Quinn = volcanic rust, Leo = Florida sea blue.
   captions: fallback caption text + speaker for every line in content/script.json (segments + responses), so the
             video works before any voice is recorded. assets/vo/lines.json / who.json (what was recorded) win.
   Puppets: the cast (DESIGN.md §3) — quinn (quinn, quinn_point), leo (leo_cross, leo_point). Facing of the
            generated art (Puppet.NATIVE, assets/ASSETS.md): quinn and leo_cross face the front (0, never mirrored);
            quinn_point points to the viewer's left (-1: drawn as is when she stands on the right, facing -1);
            leo_point raises his finger on the viewer's left (-1: Leo stands on the left facing +1, so the art is
            mirrored and the finger goes up on the side toward Quinn, not off the frame edge).
   ========================================================================== */
window.LessonHooks = {
  speakers: { quinn: { name: 'Dr. Quinn', color: '#b4472a' }, leo: { name: 'Leo', color: '#1f6f94' } },
  captions({ script }) {
    const text = {}, who = {};
    const add = l => { text[l.id] = l.text; who[l.id] = l.who; };
    if (script) { script.segments.forEach(sg => (sg.lines || []).concat(sg.after || []).forEach(add)); (script.responses || []).forEach(add); }
    return { text, who };
  },
};

/* the cast's poses (core/puppet.js: pose alias → image name; the first/default pose per character) */
(function () {
  const P = typeof window !== 'undefined' && window.Puppet;
  if (!P) return;                                   // node (tools/contentcheck.js reads only the speakers)
  P.POSES.quinn = { quinn: 'quinn', point: 'quinn_point', quinn_point: 'quinn_point' };
  P.POSES.leo = { cross: 'leo_cross', point: 'leo_point', leo_cross: 'leo_cross', leo_point: 'leo_point' };
  P.DEFAULT.quinn = 'quinn'; P.DEFAULT.leo = 'leo_cross';
  Object.assign(P.NATIVE, { quinn: 0, quinn_point: -1, leo_cross: 0, leo_point: -1 });
})();
